//This file is automatically rebuilt by the Cesium build process.
export default "czm_pbrParameters czm_defaultPbrMaterial()\n\
{\n\
czm_pbrParameters results;\n\
results.diffuseColor = vec3(1.0);\n\
results.roughness = 1.0;\n\
const vec3 REFLECTANCE_DIELECTRIC = vec3(0.04);\n\
results.f0 = REFLECTANCE_DIELECTRIC;\n\
return results;\n\
}\n\
";
